import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsDataService } from '$modules/personal/notifications/notifications-data.service';
import { NotificationsHttpService } from '$modules/personal/notifications/notifications-http.service';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { finalize } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Notification } from '$modules/personal/notifications/model/notifications-model';
import * as dayjs from 'dayjs';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-show-notification',
  templateUrl: './show-notification.component.html',
  styleUrls: ['./show-notification.component.scss'],
})
export class ShowNotificationComponent implements OnInit, OnDestroy {
  public notification$ = new BehaviorSubject<Notification | null>(null);
  public isLoading$ = new BehaviorSubject<boolean>(false);
  public readonly faChevronLeft = faChevronLeft;
  public readonly dayjs = dayjs;
  public showFallbackImage = false;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly notificationsHttpService: NotificationsHttpService,
    private readonly notificationsDataService: NotificationsDataService
  ) {}

  public ngOnInit() {
    this.getNotificationById(this.route.snapshot.paramMap.get('id'));
  }

  public getNotificationById(id: string) {
    this.notificationsHttpService
      .getNotificationById(id)
      .pipe(
        untilDestroyed(this),
        finalize(() => this.isLoading$.next(false))
      )
      .subscribe((notification) => {
        this.notification$.next(notification);
        this.notificationsDataService.refresh$.next();
      });
  }

  public navigateBack(): void {
    void this.router.navigate(['/personal/notifications']);
  }

  public enableFallbackImg(): void {
    this.showFallbackImage = true;
  }

  public ngOnDestroy() {}
}
